module.exports = __webpack_public_path__ + "static/media/lep_sound_2.ef09dfcf.wav";


//////////////////
// WEBPACK FOOTER
// ./src/components/containers/play-screen/easter-eggs/saint_patricks_day/lep_sounds/lep_sound_2.wav
// module id = 446
// module chunks = 0